module.exports = __webpack_public_path__ + "static/img/signet-de.958c68e3.png";